import { useEffect, useState } from 'react';
import styles from './Final.module.scss';
import classNames from 'classnames';
import { OPERATOR, DRIVER, LAB, FILLER, stories } from '@/src/constants';
import { createText } from '@/src/utils/createText';
import { Footer } from '@/src/components/Footer';
import { CSSTransition } from 'react-transition-group';
import sendEventToCounters from '@/src/counterEvents';

type TProps = {
  changePage: (pageName: string) => void;
  activeStory: string;
};

export const Final = ({ changePage, activeStory }: TProps) => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    });
  }, []);

  const [isAnimated, setIsAnimated] = useState(false);

  let timerId: ReturnType<typeof setTimeout>;

  useEffect(() => {
    timerId = setTimeout(() => {
      setIsAnimated(true);
    }, 1);

    return () => clearTimeout(timerId);
  }, []);

  const getLink = () => {
    switch (activeStory) {
      case OPERATOR:
        return 'https://my.hh.ru/dA';
      case DRIVER:
        return 'https://my.hh.ru/h6';
      case LAB:
        return 'https://my.hh.ru/hN';
      case FILLER:
        return 'https://my.hh.ru/i0';
      default:
        break;
    }
  };

  const handleGoGameAgain = () => {
    changePage('start');
    switch (activeStory) {
      case OPERATOR:
        sendAnalyticsStories('kassir_azs');
        break;
      case DRIVER:
        sendAnalyticsStories('voditel');
        break;
      case LAB:
        sendAnalyticsStories('laborant');
        break;
      case FILLER:
        sendAnalyticsStories('napolnitel');
        break;
      default:
        break;
    }
  };

  const handleGoToVacancies = () => {
    switch (activeStory) {
      case OPERATOR:
        sendAnalyticsVacancies('kassir_azs');
        break;
      case DRIVER:
        sendAnalyticsVacancies('voditel');
        break;
      case LAB:
        sendAnalyticsVacancies('laborant');
        break;
      case FILLER:
        sendAnalyticsVacancies('napolnitel');
        break;
      default:
        break;
    }
  };

  const sendAnalyticsVacancies = (action: string) => {
    sendEventToCounters({ action, label: 'final-vacancies' });
  };

  const sendAnalyticsStories = (action: string) => {
    sendEventToCounters({ action, label: 'final-stories' });
  };

  return (
    <div className={classNames(styles.final, 'final')}>
      <div className={styles.top}>
        <div className={classNames('container', styles.container)}>
          <div className={classNames(styles.topWrapper, styles[activeStory])}>
            <div className={styles.image}>
              <img src={stories[activeStory].image} alt="" />
            </div>
            <div className={styles.wrap}>
              <CSSTransition
                in={isAnimated}
                timeout={200}
                classNames="fadeLeft"
              >
                <div
                  className={classNames(
                    styles.wrapTop,
                    'fadeLeft',
                    'fadeTitle',
                  )}
                >
                  <div
                    className={styles.title}
                    dangerouslySetInnerHTML={createText(
                      stories[activeStory].title,
                    )}
                  ></div>
                </div>
              </CSSTransition>
              <CSSTransition
                in={isAnimated}
                timeout={200}
                classNames={activeStory === LAB ? 'fadeRight' : 'fadeLeft'}
              >
                <div
                  className={classNames(
                    styles.content,
                    activeStory === LAB ? 'fadeRight' : 'fadeLeft',
                    'fadeContent',
                  )}
                >
                  <div
                    className={styles.contentTitle}
                    dangerouslySetInnerHTML={createText(
                      stories[activeStory].finalText,
                    )}
                  ></div>
                  <div className={styles.buttons}>
                    <a
                      href={getLink()}
                      target="_blank"
                      rel="noreferrer"
                      className={classNames('button', styles.finalButton)}
                      onClick={handleGoToVacancies}
                    >
                      Да, посмотреть вакансии!
                    </a>
                    <button
                      className={classNames(
                        'button',
                        styles.finalButton,
                        styles.buttonBlue,
                      )}
                      onClick={handleGoGameAgain}
                    >
                      Узнать другие истории
                    </button>
                  </div>
                </div>
              </CSSTransition>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <Footer />
      </div>
    </div>
  );
};
